module.exports = __webpack_public_path__ + "r-v3/img/diamond.e22abd8e.svg";